import { UserData, UserRole } from "../models/userData";

export const UserHasRole = (user: UserData, role: UserRole): boolean => {
    return UserHasRoles(user, [role]);
};

export const UserHasRoles = (user: UserData, roles: UserRole[]): boolean => {
    if (user.roles) {
        return user.roles.some(value => roles.includes(value));
    } else {
        return false;
    }
};

export const UserDetailsHasRoles = (userRoles: UserRole[], roles: UserRole[]): boolean => {
    if (userRoles) {
        return userRoles.some(value => roles.includes(value));
    } else {
        return false;
    }
};

export const GetRoleLink = (user: UserData): string => {
    const linkString: string = UserHasRole(user, UserRole.Admin) ? "staff" : "my-data";
    return linkString;
};
